import { useState, useEffect } from "react";
import { USER_DATA } from "../../utils/constants";
import RepositoriesScreen from "./Repositories.screen";
import { getRepositories, saveRepository } from "../../api/repository";
import { toast } from "react-toastify";
import { RepositoryTypes } from "../../interfaces/RepositoryTypes";

export default function RepositoriesContainer() {
  const [nickName, setNickName] = useState('');
  const [repositoryName, setRepositoryName] = useState('');
  const [pipeline, setPipeline] = useState('');

  const [loading, setLoading] = useState(true);
  const [repositories, setRepositories] = useState<RepositoryTypes[]>([]);

  useEffect(() => {
    fetchRepositories();
  }, []);

  const fetchRepositories = async () => {
    setLoading(true);

    const user_uuid = JSON.parse(localStorage.getItem(USER_DATA) || '{}').uid

    getRepositories(user_uuid)
      .then((response: any) => {
        setRepositories(response)
      })

    setLoading(false);
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!pipeline.includes('.yml')) {
      toast.error('Pipeline deve ser um arquivo .yml');
      return
    }

    if (nickName != '' && repositoryName != '' && pipeline != '') {
      const user_uuid = JSON.parse(localStorage.getItem(USER_DATA) || '{}').uid

      const data = {
        nick_name: nickName,
        repository_name: repositoryName,
        pipeline,
        user_uuid: user_uuid,
        create_at: new Date().toUTCString()
      }

      saveRepository(data)
        .then(() => {
          toast.success('Repositório salvo com sucesso');
          setNickName('');
          setRepositoryName('');
          setPipeline('');
          fetchRepositories();
        })
    }
  }

  return (
    <RepositoriesScreen
      loading={loading}
      repositories={repositories}
      nickName={nickName}
      setNickName={setNickName}
      repositoryName={repositoryName}
      setRepositoryName={setRepositoryName}
      pipeline={pipeline}
      setPipeline={setPipeline}
      handleSubmit={handleSubmit}
    />
  );
}
